/**
 * Add connection component save, update and clone connection to database as well upload content images and hero image to s3 bucket.
 */

import CKEditor from "ckeditor4-react";
import * as _ from "lodash";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { deviceDetect } from "react-device-detect";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { BackStrip, Header } from "../../../common/layout";
import { utilService } from "../../../common/utils";
import { config } from "../../../config/config";
import { routes } from "../../../routes";
import * as postsActions from "../../../store/admin";

// CKEditor.stylesSet.add('my_styles', [
//   // Block-level styles
//   { name: 'Blue Title', element: 'h2', styles: { 'color': 'Blue' } },
//   { name: 'Red Title', element: 'h3', styles: { 'color': 'Red' } },

//   // Inline styles
//   { name: 'CSS Style', element: 'span', attributes: { 'class': 'my_style' } },
//   { name: 'Marker: Yellow', element: 'span', styles: { 'background-color': 'Yellow' } }
// ])

class AddConnection extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onFeaturedImgchange = this.onFeaturedImgchange.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.onFileUploadReq = this.onFileUploadReq.bind(this);
    this.onFileUploadRes = this.onFileUploadRes.bind(this);
    this.handlePublishedRadiobox = this.handlePublishedRadiobox.bind(this);
    this.onFeatureImgError = this.onFeatureImgError.bind(this);
    this.onDeletePost = this.onDeletePost.bind(this);
    this.onClonePost = this.onClonePost.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
    this.subscriptions = [];
    this.state = {
      postData: {
        make_public: false,
        published: true,
        publish_start: new Date(),
        publish_end: new Date(),
        clone: false,
      },
      excerpt_change: false,
      format_content_html: "",
      featuredImgFileObj: null,
      featuredImgUrl: "",
      featuredImgBase64Url: "",
      errors: {},
      isLoading: false,
      isSaving: false,
      isdeleteing: false,
      isCloning: false,
      isClose: false,
      editorInstance: null,
    };
    this.addSubScription = null;
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();
    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "add-newsletter",
      title: "Add Newsletter",
      browserName: browserName,
      osName: osName,
      pageType: "Add Newsletter Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });
    const id = this.props.match.params.id;
    if (id) {
      this.props.fetchPost({
        id: this.props.match.params.id,
        token: this.props.token,
      });
    }
    this.props.fetchCategories({
      token: this.props.token,
      params: "?category_type=All",
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('previouse post...', prevProps)
    // console.log('prevProps.postActionLoading', prevProps.postActionLoading);
    // console.log('current action loading...', this.props.postActionLoading)
    // console.log(this.props.post)
    // console.log(prevState)
    if (this.state.isClose || this.state.isCloning) {
      if (prevProps.postActionLoading && !this.props.postActionLoading) {
        NotificationManager.success(
          "Success message",
          "Newsletter saved successfully."
        );
        this.props.history.push("/admin");
      }
    } else if (this.state.isSaving && !this.state.isClose) {
      if (prevProps.postActionLoading && !this.props.postActionLoading) {
        // Get current postUid after save post
        let currentPostUid = this.props.currentPostUid;

        const id = this.props.match.params.id;

        if (id) {
          // Get current post after click on save button
          this.props.fetchPost({
            id: currentPostUid,
            token: this.props.token,
          });

          this.subscriptions = [];
          this.addSubScription = null;
          this.setState(
            {
              errors: {},
              isLoading: false,
              isSaving: false,
              isdeleteing: false,
              isCloning: false,
              isClose: false,
            },
            function () {
              NotificationManager.success(
                "Success message",
                "Newsletter saved successfully."
              );
            }
          );
        } else {
          this.props.history.push("/admin/edit-newsletter/" + currentPostUid);
          NotificationManager.success(
            "Success message",
            "Newsletter saved successfully."
          );
        }

        // let fields = this.state.postData;
        // fields = {};
        // fields['make_public'] = false;
        // fields['published'] = true;
        // fields['publish_start'] = new Date()
        // fields['publish_end'] = new Date()
        // fields['clone'] = false
        // this.setState({
        //   ...this.state,
        //   postData: fields,
        //   excerpt_change: false,
        //   format_content_html: '',
        //   featuredImgFileObj: null,
        //   featuredImgUrl: '',
        //   featuredImgBase64Url: '',
        //   errors: {},
        //   isLoading: false,
        //   isSaving: false,
        //   isdeleteing: false,
        //   isCloning: false,
        //   isClose: false,
        //   editorInstance: null
        // })
      }
    }
    // if (prevProps.postActionLoading !== this.props.postActionLoading) {
    //   this.props.history.push('/admin');
    // }
  }
  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('nex props...', nextProps)
    // console.log(this.props)

    if (nextProps.post) {
      if (nextProps.post !== this.props.post) {
        // console.log('111')
        let postJson = nextProps.post;
        let image_url = postJson["featured_img_url"];
        postJson["featured_img_url"] = postJson["postUid"];
        if (postJson.published) {
          postJson.publish_start = new Date(postJson.publish_start);
          postJson.publish_end = new Date(postJson.publish_end);
        }
        this.setState({
          ...this.state,
          postData: postJson,
          featuredImgUrl: image_url,
          excerpt_change: postJson.excerpt ? true : false,
        });
      }
    }
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    // console.log(name, value)
    let fields = this.state.postData;
    let excerpt_change = this.state.excerpt_change;
    if (name === "title") {
      let slug = value.trim();
      slug = slug.toLowerCase();
      slug = slug.split(" ");
      slug = slug.filter((e) => e !== "");
      slug = slug.join("-");
      fields["slug"] = slug;
    }
    if (name === "make_public") {
      fields["make_public"] = e.target.checked;
    } else {
      fields[name] = value;
    }
    if (name === "excerpt" && value) {
      excerpt_change = true;
    } else if (name === "excerpt" && !value) {
      excerpt_change = false;
    }
    this.setState({
      fields,
      excerpt_change,
    });
  }

  onClonePost(e) {
    e.preventDefault();

    if (this.validateForm()) {
      // console.log(this.state.postData);
      let content_string = this.state.postData["content_html"];
      // let res = this.getAttrFromString(this.state.postData['content_html'], 'img', 'src');
      let res = this.getAttrFromString(
        this.state.postData["content_html"],
        "img",
        "src",
        "style"
      );
      res.map(async function (single) {
        let url = single.key;
        url = url.replace(config.url.media_bucket_url, "");
        url = url.split("?");
        // console.log(url);
        let key = url[0].split("/");
        content_string = content_string.replace(single.key, key[1]);
        // console.log(content_string);
      });

      // add style attribute to anchor tage
      // let regex = new RegExp('<a.*?href="(.*?)"', "gi");
      // let result = []
      // while ((result = regex.exec(content_string))) {
      //   if (result[1]) {
      //     let link = result[1] + '" style="color: #C41425;text-decoration: none;"'
      //     content_string = content_string.replace(result[1], link);
      //   }
      // }

      let regex = new RegExp('<a.*?href="(.*?)"(.*?)</a>', "gi");

      let result = [];

      while ((result = regex.exec(content_string))) {
        // console.log(result)
        if (result[0]) {
          let href_attribute = result[1];

          let content_first_part = content_string.substr(0, result["index"]);

          let str_second_part = content_string.substring(
            result["index"],
            regex.lastIndex
          );

          let content_second_part_list = str_second_part.split(" ");

          if (!result[0].includes('style="')) {
            // console.log('first............', content_string.substr(0, result['index']))

            // console.log('second...........', content_string.substring(result['index'], regex.lastIndex))

            content_second_part_list[0] =
              content_second_part_list[0] +
              ' style="color: #C41425;text-decoration: none;"';
          }

          let path_match = false;
          if (!result[0].includes('target="_blank"')) {
            routes.forEach((item, index) => {
              let path = item["path"];
              if (path !== "/" && path !== "/docusign" && path !== "/docusignboarder" ) {
                if (
                  href_attribute.includes(path) ||
                  href_attribute.includes("https://places.plc.sydney") ||
                  href_attribute.includes("http://devplaces.plc.sydney")
                ) {
                  path_match = true;
                }
              }
            });
            if (!path_match) {
              content_second_part_list[0] =
                content_second_part_list[0] + ' target="_blank"';
            }
          }

          // console.log(href_attribute)
          // let link = result[1] + ' style="color: #C41425;text-decoration: none;"'

          let changed_string = content_second_part_list.join(" ");
          str_second_part = changed_string;

          // console.log("Changed String.............", changed_string);

          let content_third_part = content_string.substr(regex.lastIndex);

          // console.log('third.......', content_string.substr(regex.lastIndex))

          content_string =
            content_first_part + str_second_part + content_third_part;

          // console.log(content_string)

          // console.log('Result............', result[1])
          // console.log('link..............', link)

          // content_string = content_string.replace(result[1], link);
          // console.log(content_string)
          // debugger
        }
      }

      // console.log(content_string);
      let fields = this.state.postData;
      fields["content_html"] = content_string;
      delete fields["postUid"];
      fields["clone"] = true;
      fields["created_at"] = new Date();
      fields["updated_at"] = new Date();
      fields["users_userid"] = this.props.user.userUid;
      fields["users_username"] = this.props.user.username;
      fields["users_firstname"] = this.props.user.firstname;
      fields["users_lastname"] = this.props.user.surname;
      this.setState(
        {
          fields,
          isLoading: true,
          isSaving: false,
          isCloning: true,
        },
        function () {
          this.props.createPost(this.props.token, this.state.postData);
        }
      );

      // let imgTypeAr = fields['featured_img_url'].split(".");
      // let imgType = imgTypeAr[imgTypeAr.length - 1];
      // // console.log(imgType);
      // if (imgType === 'jpeg' || imgType === 'jpg' || imgType === 'png' || imgType === 'JPEG' || imgType === 'JPG' || imgType === 'PNG') {
      //   delete fields['postUid'];
      //   fields['clone'] = true;
      //   fields['featured_img_type'] = imgType;

      //   // console.log(this.state.postData);

      // } else {
      //   alert('Invalid image...');
      //   return;
      // }
    }
  }
  onEditorChange(e) {
    console.log(e);
    let fields = this.state.postData;
    let editor_text = e.editor.document.getBody().getText();
    fields["content_html"] = e.editor.getData();
    // const id = this.props.match.params.id;
    // if (id) {
    //   if (this.state.init_excertp) {
    //     fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    //   }
    // } else {
    //   fields['excerpt'] = editor_text ? editor_text.slice(0, 150) : '';
    // }
    if (!this.state.excerpt_change) {
      fields["excerpt"] = editor_text ? editor_text.slice(0, 150) : "";
    }
    this.setState({
      // init_excertp: fields['excerpt'],
      fields,
      editorInstance: e.editor,
    });
  }

  /**
   * Summary. Function used to send server request to upload image.
   *
   * @param {*} e  ckeditor upload event
   */
  onFileUploadReq(e) {
    // console.log(e);
    let xhr = e.data.fileLoader.xhr;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Authorization", "Bearer " + this.props.token);
    xhr.send(
      JSON.stringify({ base64ImageUrl: e.data.fileLoader.data.split(",")[1] })
    );
    e.stop();
    e.cancel();
  }

  /**
   * Summary. Function used to get response of upload editor image from server.
   * @param {*} e upload response event
   */
  onFileUploadRes(e) {
    e.stop();
    // console.log(e.data);
    let data = e.data;
    let xhr = data.fileLoader.xhr;
    // console.log(xhr)
    let response = xhr.responseText.split("|");
    // console.log(response)
    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      e.cancel();
    } else {
      let parse_response = JSON.parse(response[0].toString());
      data.url = parse_response["responceObject"]["records"]["url"];
    }
  }

  onFeaturedImgchange(e) {
    if (e.target.files[0]) {
      let fields = this.state.postData;
      let url = this.getBase64Image(e.target.files[0]);
      url.then((result) => {
        // console.log(result)
        fields["featuredImage"] = result;
      });
      this.setState({
        fields,
        featuredImgUrl: URL.createObjectURL(e.target.files[0]),
        featuredImgFileObj: e.target.files[0],
      });
    }
  }
  getBase64Image(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        // console.log(reader.result);
        // resolve(reader.result)
        resolve(reader.result.split(",")[1]);
        // return reader.result
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
        reject("");
      };
    });
  }
  onFeatureImgError(e) {
    this.setState({
      featuredImgUrl: "assets/img/no-image.png",
    });
  }
  handleDateChange(date, name) {
    // console.log(date)
    // console.log(this.state)
    let fields = this.state.postData;
    fields[name] = date;
    this.setState({
      fields,
    });
  }
  handlePublishedRadiobox(e) {
    const { name } = e.target;
    // console.log(name, value)
    let fields = this.state.postData;
    fields["publish_start"] = null;
    fields["publish_end"] = null;
    if (e.target.value === "false") {
      fields[name] = false;
    } else {
      fields[name] = true;
    }
    this.setState({
      fields,
    });
  }
  validateForm() {
    let fields = this.state.postData;
    let errors = {};
    let formIsValid = true;

    if (!fields["title"]) {
      formIsValid = false;
      errors["title"] = "*Please enter title.";
    }
    if (!fields["slug"]) {
      formIsValid = false;
      errors["slug"] = "*Please enter slug.";
    }
    if (!fields["content_html"]) {
      formIsValid = false;
      errors["content_html"] = "*Please enter content html";
    }
    if (
      fields["published"] &&
      (!fields["publish_start"] || fields["publish_start"] === null)
    ) {
      formIsValid = false;
      errors["publish_start"] = "*Please select start date.";
    }
    if (
      fields["published"] &&
      fields["publish_end"] < fields["publish_start"]
    ) {
      formIsValid = false;
      errors["publish_end"] = "*Please select valid date.";
    }
    if (
      fields["published"] &&
      (!fields["publish_end"] || fields["publish_end"] === null)
    ) {
      formIsValid = false;
      errors["publish_end"] = "*Please select end date.";
    }
    if (!fields["postcategory_categoryid"]) {
      formIsValid = false;
      errors["postcategory_categoryid"] = "*Please select one category.";
    }
    if (!this.state.featuredImgUrl && !fields["featuredImage"]) {
      formIsValid = false;
      errors["featuredImage"] = "*Please select image.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  onDeletePost(e) {
    e.preventDefault();
    const id = this.props.match.params.id;
    if (id) {
      this.setState({
        isDeleating: true,
      });
      this.props.deletePost({
        id: id,
        token: this.props.token,
      });
    }
  }

  /**
   * Summary. Function used to find image tag and src attribute from content_html.
   * @param {*} str  content html string
   * @param {*} node tage (img)
   * @param {*} attr attriubte (src)
   */
  getAttrFromString(str, node, attr, style) {
    // let regex = new RegExp('<' + node + ' .*?' + attr + '="(.*?)" />', "gi"),
    //   result, res = [];
    let regex = new RegExp(
        "<" + node + " .*?" + attr + '="(.*?)" ' + style + '="(.*?)" />',
        "gi"
      ),
      result,
      res = [];
    while ((result = regex.exec(str))) {
      var obj = {};
      obj["tag"] = result[0];
      obj["key"] = result[1];
      obj["style"] = result[2];
      res.push(obj);
    }
    return res;
  }

  /**
   * Summary. Function used to send server request to save post content.
   * @param {*} e
   */
  onSubmit(type, e) {
    e.preventDefault();
    // console.log(this.state);
    // console.log(this.props)
    // const {} = this.props;
    if (this.validateForm()) {
      // console.log('111')
      // upload feature image to s3

      if (this.props.categories) {
        let fields = this.state.postData;
        let categories = this.props.categories;
        let catObj = _.find(categories, {
          postcategoryUid: this.state.postData.postcategory_categoryid,
        });
        fields["postcategory_categoryname"] = catObj.categoryname;
        this.setState({
          fields,
        });
      }

      // Replace content_html's img tage src attribute to save uuid of editor images.
      let content_string = this.state.postData["content_html"];
      // let res = this.getAttrFromString(this.state.postData['content_html'], 'img', 'src');
      let res = this.getAttrFromString(
        this.state.postData["content_html"],
        "img",
        "src",
        "style"
      );
      res.map(async function (single) {
        let url = single.key;
        url = url.replace(config.url.media_bucket_url, "");
        url = url.split("?");
        // console.log(url);
        let key = url[0].split("/");
        content_string = content_string.replace(single.key, key[1]);
        // console.log(content_string);
      });
      // find anchor tag from string and add style attribute to all anchor tag
      // let regex = new RegExp('<a.*?href="(.*?)"', "gi");
      // let result = []
      // while ((result = regex.exec(content_string))) {
      //   if (result[1]) {
      //     let link = result[1] + '" style="color: #C41425;text-decoration: none;"'
      //     content_string = content_string.replace(result[1], link);
      //   }
      // }

      let regex = new RegExp('<a.*?href="(.*?)"(.*?)</a>', "gi");

      let result = [];

      while ((result = regex.exec(content_string))) {
        // console.log(result)
        if (result[0]) {
          let content_first_part = content_string.substr(0, result["index"]);

          let str_second_part = content_string.substring(
            result["index"],
            regex.lastIndex
          );

          let content_second_part_list = str_second_part.split(" ");

          if (!result[0].includes('style="')) {
            // console.log('first............', content_string.substr(0, result['index']))

            // console.log('second...........', content_string.substring(result['index'], regex.lastIndex))

            content_second_part_list[0] =
              content_second_part_list[0] +
              ' style="color: #C41425;text-decoration: none;"';
          }

          // console.log(href_attribute)
          // let link = result[1] + ' style="color: #C41425;text-decoration: none;"'

          let changed_string = content_second_part_list.join(" ");
          str_second_part = changed_string;

          // console.log("Changed String.............", changed_string);

          let content_third_part = content_string.substr(regex.lastIndex);

          // console.log('third.......', content_string.substr(regex.lastIndex))

          content_string =
            content_first_part + str_second_part + content_third_part;

          // console.log(content_string)

          // console.log('Result............', result[1])
          // console.log('link..............', link)

          // content_string = content_string.replace(result[1], link);
          // console.log(content_string)
          // debugger
        }
      }

      let fields = this.state.postData;
      fields["content_html"] = content_string;
      this.setState({
        fields,
      });
      // If postUid exist it will update post content.
      if (this.state.postData.postUid) {
        // console.log(this.state.postData)
        let fields = this.state.postData;
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;
        this.setState({
          fields,
          isLoading: true,
          isSaving: type === "close" ? false : true,
          isCloning: false,
          isClose: type === "close" ? true : false,
        });
        this.props.updatePost({
          token: this.props.token,
          data: this.state.postData,
        });
      } else {
        let fields = this.state.postData;
        fields["created_at"] = new Date();
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;
        fields["type"] = "newsletter";
        fields["daily_flag"] = false;
        this.setState({
          fields,
          isLoading: true,
          isSaving: type === "close" ? false : true,
          isCloning: false,
          isClose: type === "close" ? true : false,
        });
        // console.log(this.state.postData)
        this.props.createPost(this.props.token, this.state.postData);
        // const addSubscription = this.selcetState(store.getState());
        // console.log('aloading..', addSubscription)
      }
    }
  }
  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    // console.log(this.state.postData)
    const { categories } = this.props;
    const con_id = this.props.match.params.id;
    // Sort category by sort order
    let sortedCategories = [];
    if (categories && categories.length > 0) {
      sortedCategories = categories.sort(function (a, b) {
        return new Date(a.sort_order) - new Date(b.sort_order);
      });
    }
    const categoryList =
      sortedCategories &&
      sortedCategories.map((cat, index) => (
        <label key={cat.postcategoryUid} className="typeradio">
          {cat.categoryname}
          <br />
          <input
            type="radio"
            name="postcategory_categoryid"
            onChange={this.handleInputChange}
            checked={
              this.state.postData.postcategory_categoryid ===
              cat.postcategoryUid
            }
            value={cat.postcategoryUid}
          />
          <span className="radiomark"></span>
        </label>
      ));
    return (
      <div>
        <BackStrip nav="/admin" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Add Newsletter" />
            <main className="admin-home">
              <div className="container" style={{ maxWidth: "95%" }}>
                <form ref={(el) => (this.myFormRef = el)} name="addPost">
                  <div className="row justify-content-end brd-btm">
                    <ul
                      className="nav nav-pills d-flex justify-content-center"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <NavLink className="nav-link active" to="/admin">
                          Admin Home
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Email Logs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Web Logs
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                    <h1>NEWSLETTER ARTICLE</h1>
                  </div>
                  <div className="row">
                    <div className="col-md-4 bg-offlight reps-m-2">
                      <div className="radioslide">
                        <p>Category</p>
                        <div className="errorMsg">
                          {this.state.errors["postcategory_categoryid"]}
                        </div>
                        {categoryList}
                        <div className="col-lg-12 col-xl-12">
                          {this.state.featuredImgUrl && (
                            <div className="priview">
                              <img
                                src={this.state.featuredImgUrl}
                                width="450px"
                                height="320px"
                                alt="Preview"
                              ></img>
                            </div>
                          )}
                          <div className="d-flex align-items-center flex-md-column flex-xl-row">
                            <input
                              type="file"
                              id="myFile"
                              className="custom-file-input"
                              onChange={this.onFeaturedImgchange}
                            />
                            <p>
                              Hero Image
                              <br /> (450*320)
                            </p>
                          </div>
                          <div className="errorMsg">
                            {this.state.errors["featuredImage"]}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="filters">
                        <div className="brd-1 pt-1">
                          <div className="row pt-1">
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Draft Mode
                                <br />
                                <span>(not displayed)</span>
                                <input
                                  type="radio"
                                  name="published"
                                  checked={
                                    this.state.postData.published === false
                                  }
                                  onChange={this.handlePublishedRadiobox}
                                  value={false}
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-3">
                              <label className="typeradio">
                                Post
                                <br />
                                <span>(displayed)</span>
                                <input
                                  type="radio"
                                  name="published"
                                  onChange={this.handlePublishedRadiobox}
                                  checked={
                                    this.state.postData.published === true
                                  }
                                  value={true}
                                />
                                <span className="radiomark"></span>
                              </label>
                            </div>
                            <div className="col-md-6 col-lg-3">
                              <label className="typecheck pt-0">
                                Make Public
                                <input
                                  type="checkbox"
                                  name="make_public"
                                  onChange={this.handleInputChange}
                                  checked={
                                    this.state.postData.make_public === true
                                  }
                                  value={this.state.postData.make_public}
                                />
                                <span className="typemark mt-0"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        {this.state.postData.published && (
                          <div className="brd-1 pt-1">
                            <div className="row pt-1">
                              <div className="col-lg-6">
                                <div className="date">
                                  <p className="datetext">Start Date</p>
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    minDate={new Date()}
                                    selected={this.state.postData.publish_start}
                                    onChange={(date) =>
                                      this.handleDateChange(
                                        date,
                                        "publish_start"
                                      )
                                    }
                                  />
                                  <div className="errorMsg">
                                    {this.state.errors["publish_start"]}
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="date">
                                  <p className="datetext">End Date</p>
                                  <DatePicker
                                    className="form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    minDate={this.state.postData.publish_start}
                                    selected={this.state.postData.publish_end}
                                    onChange={(date) =>
                                      this.handleDateChange(date, "publish_end")
                                    }
                                  />
                                  <div className="errorMsg">
                                    {this.state.errors["publish_end"]}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row">
                          <div className="col-lg-6 col-xl-6">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Title</label>
                              <input
                                type="text"
                                name="title"
                                className="form-control"
                                placeholder="Enter Title"
                                onChange={this.handleInputChange}
                                value={this.state.postData.title || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["title"]}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-xl-6">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Slug</label>
                              <input
                                type="text"
                                readOnly
                                name="slug"
                                className="form-control"
                                placeholder="Enter Slug"
                                value={this.state.postData.slug || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["slug"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 pt-1">
                            <div className="d-block align-items-center mt-2">
                              <label className="title-label">Content</label>
                              <CKEditor
                                onBeforeLoad={(CKEDITOR) => (
                                  (CKEDITOR.disableAutoInline = true),
                                  CKEDITOR.addCss(
                                    'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                                  )
                                )}
                                config={{
                                  versionCheck: false,
                                  stylesSet: [
                                    // Block-level styles.
                                    {
                                      name: "Content title",
                                      element: "h1",
                                      styles: {
                                        color: "#C41425",
                                        "font-family": "Open Sans Semibold",
                                        "line-height": "135%",
                                      },
                                    },
                                    {
                                      name: "Content Info",
                                      element: "p",
                                      styles: {
                                        color: "#586667",
                                        padding: "0px !important",
                                        "font-family": "Open Sans Light",
                                        "font-size": "14px",
                                      },
                                    },
                                    // Inline styles.
                                    {
                                      name: "Text Gray",
                                      element: "p",
                                      styles: {
                                        color: "#AAA !important",
                                        "font-family": "Open Sans Light",
                                        "font-size": "16px",
                                      },
                                    },
                                    {
                                      name: "Anchor Red",
                                      element: "a",
                                      styles: {
                                        color: "#C41425 !important",
                                        "text-decoration": "none",
                                      },
                                    },
                                  ],
                                  format_tags:
                                    "p;h1;h2;h3;h4;h5;h6;pre;address;div",
                                  extraPlugins: "embed,autoembed",
                                  // filebrowserBrowseUrl: '/browser/browse.php',
                                  filebrowserUploadUrl:
                                    config.api_url +
                                    config.url.upload_editor_image,
                                  embed_provider:
                                    "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
                                }}
                                onFileUploadRequest={this.onFileUploadReq}
                                onFileUploadResponse={this.onFileUploadRes}
                                onChange={this.onEditorChange}
                                data={this.state.postData.content_html || ""}
                              />
                              <div className="errorMsg">
                                {this.state.errors["content_html"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 pt-1">
                            <div className="d-block">
                              <label className="title-label">Excerpt</label>
                              <textarea
                                name="excerpt"
                                rows="8"
                                onChange={this.handleInputChange}
                                value={this.state.postData.excerpt || ""}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end pt-3">
                    {!this.state.isClose && (
                      <button
                        className="bg-primary filter-btn"
                        onClick={this.onSubmit.bind(this, "close")}
                      >
                        save & close
                      </button>
                    )}
                    {this.state.isClose && (
                      <button
                        className="bg-primary filter-btn"
                        disabled={this.state.isLoading}
                      >
                        save & close ...
                      </button>
                    )}
                    {this.state.isSaving && (
                      <button
                        disabled={this.state.isLoading}
                        className="bg-primary filter-btn"
                      >
                        save ....
                      </button>
                    )}
                    {!this.state.isSaving && (
                      <button
                        className="bg-primary filter-btn"
                        onClick={this.onSubmit.bind(this, "open")}
                      >
                        save
                      </button>
                    )}
                    {con_id && this.state.isCloning && (
                      <button
                        onClick={this.onClonePost}
                        className="bg-primary filter-btn"
                        disabled={this.state.isLoading}
                      >
                        clone ...
                      </button>
                    )}
                    {con_id && !this.state.isCloning && (
                      <button
                        onClick={this.onClonePost}
                        className="bg-primary filter-btn"
                      >
                        clone
                      </button>
                    )}
                    <NavLink to="/admin">
                      <button className="bg-dark filter-btn">cancel</button>
                    </NavLink>
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  // console.log('state....', state)
  // console.log('props.', props)
  const id = props.match.params.id;
  return {
    postActionLoading: state.posts.actionsloading,
    post: id
      ? state.posts.byId[id]
      : state.posts.currentPostUid
      ? state.posts.byId[state.posts.currentPostUid]
      : "",
    error: state.posts.error,
    token: state.user.cognito_data.token,
    user: state.user.user,
    categories: Object.values(state.category.byId),
    currentPostUid: state.posts.currentPostUid,
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(postsActions, dispatch)
)(AddConnection);
